import React from 'react'
import {
  SortableContainer,
  SortableElement,
  SortableHandle
} from 'react-sortable-hoc'
import SortHandleIcon from '../../icons/sort-handle'
import FormRow from '../form-row/form-row'

const SortableHolder = SortableContainer(({ componentRef, ...props }) => (
  <div ref={componentRef} {...props} />
))

const SortableFormRow = SortableElement(props => <FormRow {...props} />)

const SortHandle = SortableHandle(props => <SortHandleIcon {...props} />)

export { SortableHolder, SortableFormRow, SortHandle }
